export type WalletType = 'meeting' | 'crossClientQuery'

export const CROSS_CLIENT_QUERY_WALLET: WalletType = 'crossClientQuery'

export const parseCoinAmount = (value: number | string): number => Number(value)

export interface NegativeBalanceConfig {
  allowed: boolean
  limit: number | null
}

export interface PostPaidOverageConfig {
  enabled: boolean
}

export interface AutoTopUpConfig {
  enabled: boolean
  threshold: number | null
  amount: number | null
}

export interface WalletConfig {
  negativeBalance: NegativeBalanceConfig
  postPaidOverage: PostPaidOverageConfig
  autoTopUp: AutoTopUpConfig
}

export interface Wallet {
  accountId: string
  walletType: WalletType
  paidCoinBalance: number
  bundledCoinBalance: number
  totalCoinBalance: number
  config: WalletConfig
}

export interface CreditLot {
  amount: number
  expiresAt: string | null
}

export interface LedgerEntry {
  id: string
  accountId: string
  walletType: WalletType
  userId: string
  amount: number
  type: string
  metadata: Record<string, unknown>
  idempotencyKey: string
  createdAt: string
}

export interface BillingMetricsRecord {
  id: string
  userId: string
  createdAt: string
  type: string
  deleted: boolean
  context: Record<string, unknown>
  details: Record<string, unknown>
  idempotencyKey: string
}
